module.exports = __webpack_public_path__ + "img/67.eeacb4d0.jpg";